import { useAssetMembershipFilter } from './useAssetMembershipFilter';
import { useContext } from 'react';
import { useEditorActions } from './useEditorActions';
import { useFieldConditionChange } from './useFieldConditionChange';
import { useOperatorOptions } from './useOperatorOptions';
import { useTranslationHelpers } from './useTranslationHelpers';
import SegmentationFiltersInstanceContext from '../state/SegmentationFiltersInstanceContext';
export const useAssetMembershipCondition = (filterFamily, condition, conditionPath) => {
  const {
    getTrackerInstance,
    props: {
      baseFilterFamily,
      useOnePanel
    }
  } = useContext(SegmentationFiltersInstanceContext);
  const {
    getFieldLabelString
  } = useTranslationHelpers(filterFamily);
  const {
    options: operatorOptions,
    getOperatorByName
  } = useOperatorOptions(filterFamily, condition.field, condition);
  const {
    onFieldConditionOperatorChange
  } = useFieldConditionChange(filterFamily, conditionPath, condition);
  const {
    statusCondition
  } = useAssetMembershipFilter(filterFamily, condition);
  const {
    onConditionDelete
  } = useEditorActions();
  const onSelectedOptionChange = evt => {
    var _getTrackerInstance, _condition$field;
    const operatorName = evt.target.value.value;
    onFieldConditionOperatorChange(getOperatorByName(operatorName));
    (_getTrackerInstance = getTrackerInstance()) === null || _getTrackerInstance === void 0 || _getTrackerInstance.track('changedFilterOperator', {
      operator: operatorName,
      primaryObjectTypeId: baseFilterFamily,
      property: filterFamily,
      type: (_condition$field = condition.field) === null || _condition$field === void 0 ? void 0 : _condition$field.type,
      version: useOnePanel ? '2' : '1'
    });
  };
  return {
    fieldLabel: getFieldLabelString(statusCondition.field),
    onConditionDelete,
    onSelectedOptionChange,
    operatorOptions
  };
};